import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

export default function Login() {
  const { user } = useAuth();
  if (user && user !== false) return <Navigate to="/" replace />;

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050914] flex items-center justify-center p-6 relative overflow-hidden" data-testid="login-page">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_50%_20%,rgba(240,78,35,0.12),transparent_60%)]" aria-hidden="true" />
      <div className="w-full max-w-sm relative z-10">
        <div className="bg-[#0A1020] border border-[#1A2644] rounded-3xl p-8 shadow-2xl shadow-black/60 text-center">
          <div className="inline-block rounded-2xl px-6 py-3 mb-4 bg-[#040810] border border-white/10 shadow-inner">
            <img src="/logo.png?v=2" alt="Fasnet Fiber" className="h-12 w-auto object-contain mx-auto" data-testid="logo-login" />
          </div>
          <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#F04E23] font-semibold">Koneksi Stabil • Tanpa Kuota FUP</p>
          <p className="text-sm text-slate-400 mt-1.5 mb-8">Sistem Billing & Manajemen MikroTik</p>

          <Button type="button" className="w-full h-12 text-base font-semibold bg-[#F04E23] hover:bg-[#D83E15] text-white rounded-xl shadow-lg shadow-[#F04E23]/25 active:scale-[0.98] transition-all" onClick={handleGoogle} data-testid="btn-google-login">
            <svg className="w-5 h-5 mr-2.5" viewBox="0 0 24 24">
              <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" opacity="0"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
              <path fill="#FBBC05" d="M5.84 14.1a7.2 7.2 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>
            </svg>
            Masuk dengan Google
          </Button>

          <div className="mt-6 space-y-1.5 text-[11px] text-slate-400 leading-relaxed">
            <p>Email belum terdaftar? Login saja — akun Anda otomatis dibuat dengan status <span className="font-semibold text-slate-200">menunggu aktivasi admin</span>.</p>
            <p>Setelah login, Anda wajib memasukkan <span className="font-semibold text-slate-200">PIN</span> sebelum dapat mengakses sistem & bertransaksi.</p>
          </div>
        </div>
        <p className="text-center text-xs text-slate-500 mt-6 font-mono">Fasnet WiFi Billing v2.0</p>
        <p className="text-center text-xs mt-2"><a href="/bantuan-login" className="text-slate-400 underline underline-offset-2 hover:text-slate-200" data-testid="link-bantuan-login">Gagal login? Lihat Bantuan Login</a></p>
      </div>
    </div>
  );
}
